import Router from './util/Router'
import common from './routes/common'
import home from './routes/home'
import pageTemplateAbout from './routes/about'
import pageTemplateTeam from './routes/team'
import singleTeam from './routes/team'
import pageTemplatePortfolio from './routes/portfolio'
import pageTemplateNews from './routes/news'
import pageTemplateInsight from './routes/news'
import pageTemplateSpac from './routes/ventures'
import pageTemplateVentures from './routes/ventures'
// import pageTemplateSpac from './routes/ventures'
// import pageTemplateInsight from './routes/news'
import archive from './routes/archive'
import singlePost from './routes/single-post'
import pageTemplateEvents from './routes/events'

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	common,
	home,
	pageTemplateAbout,
	pageTemplateTeam,
	singleTeam,
	pageTemplatePortfolio,
	pageTemplateNews,
	pageTemplateInsight,
	pageTemplateSpac,
	pageTemplateVentures,
	archive,
	singlePost,
	pageTemplateEvents,
})

/** Load Events */
routes.loadEvents()